import { forwardRef } from 'react';

import { a, useSpring } from '@react-spring/web';
import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexElement, FlexProps } from '@spazious/dollhouse-uikit';
import { useMeasure } from '@spazious/react-hooks';

import { CloseButton } from '../CloseButton/index.js';

const AnimatedFlex = a(Flex);

const InnerPanel = styled(Flex)`
  min-width: 20vw;
  max-width: 50vw;
  flex: 1;
  width: fit-content;
  height: 100%;
`;

export type SidePanelElement = FlexElement;

export interface SidePanelProps extends FlexProps {
  open?: boolean;
  width?: number;
  onClose?: () => void;
}

export const SidePanel = styled(
  forwardRef<SidePanelElement, SidePanelProps>(
    ({ open, onClose, width: widthProp, children, ...restProps }) => {
      const [setElemetRef, { width }] = useMeasure();
      const defaultWidth = widthProp ?? width;
      const style = useSpring({
        from: {
          width: 0,
        },
        to: {
          width: open ? defaultWidth : 0,
        },
      });

      return (
        <AnimatedFlex
          style={{
            width: style.width.to((value) => `${value}px`),
          }}
          {...restProps}
        >
          <CloseButton onClick={onClose} />
          <InnerPanel ref={setElemetRef as unknown as React.RefCallback<HTMLElement>} column>
            {children}
          </InnerPanel>
        </AnimatedFlex>
      );
    }
  )
).withConfig({
  displayName: 'SidePanel',
})`
  position: relative;
  overflow: hidden;
  background-color: var(--spz-sys-color-surface-variant);
  backdrop-filter: opacity(0.5) blur(10px);
  // border-right: 1px solid var(--spz-sys-color-surface-container);
  box-shadow: var(--spz-sys-color-surface-container-high) 1px 0px 2px 0px;
  flex: 1;
`;
